module.exports = __webpack_public_path__ + "img/share-icon.ccf8abe4.svg";